import React, { useContext } from "react";

import classnames from "classnames";
import PropTypes from "prop-types";

import { useEnableRestrictSonderSignup } from "components/hooks/feature-flags";
import { useTranslation } from "components/i18n/source";
import { AppContext } from "components/store/source";

import Button from "../atoms/Button";
import Input from "../atoms/Forms/Input";
import Link from "../atoms/Link";
import Text from "../atoms/Text";
import Section from "../layouts/Section";
import Spacer from "../layouts/Spacer";

import ConfirmationCodePopupAction from "./ConfirmationCodePopupAction";

import styles from "../components/Accounts/Accounts.module.scss";

function ConfirmationCodeEntryForm({
  error,
  onChange,
  onSubmit,
  onSignUp,
  disableButton,
}) {
  const { t } = useTranslation();
  const { openLoginPopup } = useContext(AppContext);
  const enableRestrictSonderSignup = useEnableRestrictSonderSignup();

  return (
    <Section>
      <Text
        translateKey="sonder_one.popups.ConfirmationCodeSignInPopup.headerEnterConfirmationCode"
        types={["h4", "medium"]}
        className={classnames(styles.header, styles.centered_text)}
      />
      <Section orientation="column">
        <Text types={["subtitles", "red"]}>{error}</Text>
        <Input
          placeholder={t(
            "sonder_one.popups.ConfirmationCodeSignInPopup.confirmationCodePlaceHolder",
          )}
          validate={onChange}
          name="confirmationCode"
          theme="popup"
          required
        />
      </Section>
      <Spacer />
      <Text types={["cancel", "subtitles", "pre_wrap"]}>
        {t(
          "sonder_one.popups.ConfirmationCodeSignInPopup.confirmationCodeHelp1",
        )}
        <Link
          className={styles.link}
          inline
          onClick={() => openLoginPopup({ source: "Check In" })}
          textTypes={["cancel", "subtitles", "pre_wrap"]}
          translateKey="sonder_one.popups.ConfirmationCodeSignInPopup.confirmationCodeLogin"
          underline
        />
        {t(
          "sonder_one.popups.ConfirmationCodeSignInPopup.confirmationCodeHelp2",
        )}
        <Link
          className={styles.link}
          href="/contact-info"
          inline
          textTypes={["cancel", "subtitles", "pre_wrap"]}
          translateKey="sonder_one.popups.ConfirmationCodeSignInPopup.confirmationCodeHelpContact"
          underline
        />
      </Text>
      <Spacer size="s-4x" />
      <Section type="full-width">
        <Button
          textProps={{
            translateKey: "sonder_one.popups.ConfirmationCodeSignInPopup.next",
            types: ["subtitles"],
          }}
          onClick={onSubmit}
          disabled={disableButton}
          upperCase={false}
        />
      </Section>
      <Spacer size="s-4x" />
      {!enableRestrictSonderSignup && (
        <Section horizontalPosition="center" verticalPosition="center">
          <ConfirmationCodePopupAction
            prompt={
              <Text
                translateKey="sonder_one.popups.ConfirmationCodeSignInPopup.signUpMessage"
                types={["subtitles"]}
              />
            }
            cta={
              <Text
                translateKey="sonder_one.popups.ConfirmationCodeSignInPopup.signUp"
                types={["subtitles"]}
              />
            }
            link="#"
            onClick={onSignUp}
          />
        </Section>
      )}
      {!enableRestrictSonderSignup && <Spacer size="s-1x" />}
      <Section horizontalPosition="center" verticalPosition="center">
        <ConfirmationCodePopupAction
          prompt={
            <Text
              translateKey="sonder_one.popups.ConfirmationCodeSignInPopup.forgotPasswordMessage"
              types={["subtitles"]}
            />
          }
          cta={
            <Text
              translateKey="sonder_one.popups.ConfirmationCodeSignInPopup.forgotPassword"
              types={["subtitles"]}
            />
          }
          link="/accounts/password/new"
        />
      </Section>
    </Section>
  );
}

ConfirmationCodeEntryForm.propTypes = {
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onSignUp: PropTypes.func,
  disableButton: PropTypes.bool,
};

ConfirmationCodeEntryForm.defaultProps = {
  error: "",
  disableButton: "false",
  showModal: false,
  onSignUp: () => {},
};

export default ConfirmationCodeEntryForm;
